import { render, staticRenderFns } from "./Page-ActivityLog.vue?vue&type=template&id=0890d378&"
import script from "./Page-ActivityLog.vue?vue&type=script&lang=js&"
export * from "./Page-ActivityLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports